/* @flow */

import { COR_ETAPA } from '../../atendimento/constants';

import { type Etapa } from '../types';

const badgeEtapa = (etapa: Etapa) => `
    <span class="m-badge m-badge--${COR_ETAPA[etapa.etapasId]} m-badge--wide">
        ${etapa.nome}
    </span>
`;

export default badgeEtapa;
